import React from 'react';
import { Box, Heading, Page, PageContent } from 'grommet';
import { API, JobForm, Utils } from '@enrich/shared-lib';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import QueryString from 'qs';

export const NewJobForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { companies } = Utils.deepFlatten(useLoaderData());

    const duplicateJob = location.state?.duplicateJob;

    const handleSubmit = async (jobData) => {
        const response = await API.post('/api/jobs/locations', {
            data: jobData,
        });
        const newJobId = response.data.data.id;
        location.state = null; // clear duplicate job sent via location state
        navigate(`/jobs/${newJobId}`);
    };

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent align="center">
                <Heading level="2">Create New Job</Heading>
                <Box align="center">
                    <JobForm
                        companies={companies}
                        duplicateJob={duplicateJob}
                        onSubmit={handleSubmit}
                    />
                </Box>
            </PageContent>
        </Page>
    );
};

export const loader = async () => {
    const companies = await getCompanies();
    return { companies };
};

const getCompanies = async () => {
    const query = QueryString.stringify({
        fields: ['id', 'name'],
        pagination: {
            limit: 500,
        },
        sort: ['name'],
    });

    try {
        const response = await API.get(`/api/companies?${query}`);
        return response.data.data;
    } catch (error) {
        console.log(error);
    }

    return [];
};
